import React from 'react';
import PropTypes from 'prop-types';
// Material-UI
import { DataGrid, esES } from '@material-ui/data-grid';
// Context
import { useTelegram } from './TelegramContext';

const tableColumns = [
    { field: 'areaAtencion', headerName: 'Área de atención', flex: 1.5, minWidth: 140, headerAlign: 'center', align: 'center' },
    { field: 'nombreGrupo', headerName: 'Grupo', flex: 1, minWidth: 120 },
    { field: 'nivel1', headerName: 'Nivel 1', type: 'boolean', flex: 0.7, minWidth: 90, editable: true, headerAlign: 'center', align: 'center' },
    { field: 'nivel2', headerName: 'Nivel 2', type: 'boolean', flex: 0.7, minWidth: 90, editable: true, headerAlign: 'center', align: 'center' },
    { field: 'nivel3', headerName: 'Nivel 3', type: 'boolean', flex: 0.7, minWidth: 90, editable: true, headerAlign: 'center', align: 'center' },
];

export default function TelegramTable({ rows }) {
    const { setIsOptionsDisabled, selectionModel, setSelectionModel, putTelegram } = useTelegram();

    const handleCommit = (edit) => {
        const row = rows.find(r => r.id === edit.id);
        if (!row) return;
        putTelegram({
            codigo: row.codigo,
            nombreGrupo: row.nombreGrupo,
            areaAtencion: row.areaAtencion,
            nivel1: edit.field === 'nivel1' ? edit.value : row.nivel1,
            nivel2: edit.field === 'nivel2' ? edit.value : row.nivel2,
            nivel3: edit.field === 'nivel3' ? edit.value : row.nivel3,
        });
    };

    return (
        <DataGrid
            disableColumnFilter
            disableDensitySelector
            checkboxSelection
            columns={tableColumns}
            localeText={esES.props.MuiDataGrid.localeText}
            rows={rows}
            onCellEditCommit={handleCommit}
            onSelectionModelChange={(newSelectionModel) => {
                setIsOptionsDisabled(newSelectionModel.length === 0);
                setSelectionModel(newSelectionModel);
            }}
            selectionModel={selectionModel}
            hideFooterSelectedRowCount
        />
    );
}

TelegramTable.propTypes = {
    rows: PropTypes.array.isRequired,
};
